import React, {Component} from 'react';
import styled from 'styled-components';
import {brk} from "../styles/constants";
import BlockImageLeft from './BlockImageLeft'
import BlockImageRight from './BlockImageRight'


const Container = styled.div`

    h2 {
        font-family: 'Times', serif;
        font-size : 24px;
        font-weight : 600;
        text-align : center;
    }
    h3, p{ 
        font-family: 'Raleway', sans-serif;
    }
    
    
    h3{
        margin-top : 30px;
        text-align : center;
        font-style : italic;
    }
    p{
        margin-top : 20px;
        text-align : justify;
    }
   
`;





class ContentList extends Component {
    render() {
        const {
            content
        } = this.props;

        return (
            <Container >
                {
                    content.map((block, i) => {
                        if( i%2 == 0 ){
                            return <BlockImageLeft block={block}/>
                        }else{
                           return  <BlockImageRight block={block}/>
                        }
                    })

                }

            </Container>
        )
    }
}


export default ContentList;